import shuffle from '@huasi/text-shuffle';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class ScrollFunc {
  constructor() {
    this.init();
  }

  init() {
    this.setScrollTrigger();
  }

  setScrollTrigger() {
    const revealElm =
      document.querySelectorAll<HTMLElement>('.js-scrollreveal');

    revealElm.forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        //markers: true,

        onEnter: () => {
          //shuffle In 1回のみ
          if (
            el.getAttribute('data-shuffle') === '1' &&
            el.getAttribute('data-reveal') !== '1'
          ) {
            const dur = el.getAttribute('data-duration') || 0.5;
            const shuffledtxt = shuffle({
              text: el.getAttribute('data-txt') || '',
              duration: +dur,
              onUpdate: (shuffleStr) => {
                el.textContent = shuffleStr;
              },
            });
          }

          //Set Reveal
          el.setAttribute('data-reveal', '1');
        },
      });
    });
  }
}
